module.exports = __webpack_public_path__ + "img/not_found.bc5112fc.svg";